import React from 'react';
import {
    BooleanField,
    DateField,
    EmailField,
    Show,
    SimpleShowLayout,
    TextField,
} from 'react-admin';

export const UserShow = (props) => (
    <Show { ...props }>
        <SimpleShowLayout>
            <TextField label="ID" source="id" />
            <TextField label="Username" source="username" />
            <TextField label="First Name" source="first_name" />
            <TextField label="Last Name" source="last_name" />
            <EmailField label="Email" source="email" />
            <TextField label="Password" source="password" />
            <BooleanField label="Claimed?" source="claimed" />
            <BooleanField label="Enabled?" source="enabled" />
            <BooleanField label="Opted In?" source="opted_in" />
            <TextField label="Confirmation Token" source="confirmation_token" />
            <TextField label="Roles" source="roles" />
            <DateField label="Last Updated" showTime source="updated_at" />
            <DateField label="Created" showTime source="created_at" />
        </SimpleShowLayout>
    </Show>
);
